/* eslint-disable @typescript-eslint/no-use-before-define */
import {
  Applicant,
  ApplicantAddressType,
  ApplicationProps,
  Broker,
  individuals_Poa_nonIndividuals_Documents,
  JointholderRelationMaster,
  Document,
  Bank,
} from '../redux-store/types/api-types';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  applicantStatusMasters,
  APPLICATION_LISTING_STATUS,
  APPLICATION_TYPE,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  ApplicationStatusBasedOnRole,
  BloodRelations,
  CurrencyMaster,
  defaultCurrency,
  DLCLMasters,
  ENABLE_RTA_APPROVER,
  FEE_TYPE_EXTENDED_MASTER,
  FEE_TYPE_MASTER,
  IndividualApplicationStatusBasedOnRole,
  isNaturalParent,
  onboardingTypeMasters,
  RiskProfileEnabled,
  KBOLT_XALT_MASTER,
  SALT,
  SALT2,
  SAVE_LATER_VALIDATION_CHECK,
  TEXT_TABULAR_MASTER,
  UboTypeMaster,
  USER_ROLES,
  YES_NO_MASTER,
} from './constant';
import { ToWords } from 'to-words';
import { individualPanRegex, nonIndividualPanRegex, numberRegex } from './regex';
import _ from 'lodash';
import { mdmsCountriesList, togglerType } from '../redux-store/types/mdms';
import { updatedRiskProfile } from '../components/investors/riskProfileDetails';
import en from '../lang/en-us';
import { KycApplicationResponse } from '../redux-store/types/kyc';
import {
  document_object,
  documentProps,
  nomineeDocumentProps,
} from '../components/investors/documentDetails';
import { documentProps as nonIndDocumentProps } from '../components/NonIndividualInvestor/DocumentDetails';
import { topUpPlanType } from '../redux-store/types/funds';
import { topUpPlanInitialValues } from '../components/FundsSetup/addPlan';
import * as countryCodes from 'country-codes-list';
import {
  MenuItemListLink,
  NonIndividualMenuItemListLink,
} from '../components/investors/components';

export const maskMobileNumber = (mobileNumber: string): string => {
  if (!mobileNumber) {
    return '';
  }
  return (
    mobileNumber.slice(0, 2) +
    mobileNumber.slice(2, mobileNumber.length - 2).replace(/\d/g, '*') +
    mobileNumber.slice(mobileNumber.length - 2)
  );
};

export const changeGoalVal = (
  ans: string,
  riskProfileData: updatedRiskProfile[],
  question: string
): string[] => {
  const ansArray = ans.split('*').map((val) => {
    const index = val.indexOf('_');
    const result = val.substring(0, index);
    return result;
  });
  const valueArray = riskProfileData.find((profile) => profile?.question === question)?.values;
  const labelsArray = ansArray.map((key) => {
    const item = valueArray?.find((val) => val.key === key);
    return item ? `${item.label}` : key;
  });
  return labelsArray;
};

export const getApplicantName = (index: number, isNomineeOrBank?: boolean): string => {
  if (index === 1) {
    return isNomineeOrBank ? 'First' : 'First/Sole';
  } else if (index === 2) {
    return 'Second';
  } else {
    return 'Third';
  }
};

export const minDateForContributor = (): Date => {
  const date = new Date();
  date.setFullYear(date.getFullYear() - 18);
  return date;
};

export const isFirstApplicant = (applicantType: string): boolean => {
  return ['firstapplicant', '1'].includes(applicantType || '');
};

export const getFirstHolderName = (applicants: Partial<Applicant>[]): string => {
  return (
    applicants.find((applicant) => isFirstApplicant(applicant?.applicant_type || ''))?.name || 'N/A'
  );
};

export const getApplicantType = (applicantType: string | undefined): string => {
  if (applicantType) {
    if (['firstapplicant', '1'].includes(applicantType)) {
      return '1';
    } else if (['secondapplicant', '2'].includes(applicantType)) {
      return '2';
    } else {
      return '3';
    }
  }
  return '';
};

export const formatToIndianCurrency = (value: number | null): string => {
  const options: { style: 'currency'; currency: 'INR' } = { style: 'currency', currency: 'INR' };
  if (value) {
    return new Intl.NumberFormat('en-IN', options).format(value);
  }
  return '';
};

export function toExactSubstr(str: string): string {
  const a = str.split('.');
  if (a.length == 2) {
    return a[0]?.concat('.', a[1].substr(0, 2));
  }
  return str;
}

export const formatCurrency = (value?: number | null): string => {
  const formats = ['K', 'L', 'Cr'];
  // eslint-disable-next-line
  let amount: any = Number(value);
  formats.some((key, i) => {
    const size = Math.pow(10, i === 0 ? 3 : 3 - 1);
    if (size <= amount) {
      amount = toExactSubstr(`${amount / size}`);
      if (amount >= 100 && i < formats.length - 1) {
        i++;
      } else {
        // amount = (amount * decPlaces) / decPlaces;
        amount += ' ' + formats[i];
        return true;
      }
    } else {
      return true;
    }
  });
  return amount;
};

export const EIGHTEEN_YEARS_IN_MILLISECONDS = 18 * 31556926 * 1000; //  18 * no of seconds in a Year * 1000

export const isMinor = (dateOfBirth = ''): boolean => {
  return new Date().getTime() - new Date(dateOfBirth).getTime() < EIGHTEEN_YEARS_IN_MILLISECONDS;
};

// // eslint-disable-next-line @typescript-eslint/no-var-requires
// const countryCodes = require('country-codes-list');
export const getCountryCodes = (): { label: string; key: string; countryCode: string }[] => {
  const countryCodesObject: { [key: string]: string } = countryCodes.customList(
    'countryCode',
    '{countryNameEn}: +{countryCallingCode}'
  );

  const modifiedCodes = Object.keys(countryCodesObject).map((cc) => ({
    label: countryCodesObject[cc],
    key: countryCodesObject[cc].split(':')[1].trim(),
    countryCode: cc,
  }));
  return modifiedCodes;
};

export const getAddressFields = (addressType: string): ApplicantAddressType => {
  return {
    address1: '',
    address2: '',
    address3: '',
    city: '',
    district: '',
    state: '',
    country: addressType === 'overseas' ? '' : 'INDIA',
    pincode: '',
    permanentAddressSameAsCorresponding: false,
    address_type: addressType,
    isActive: true,
    fetchedFromKRA: null,
    fetchedFromDigiLocker: null,
  };
};

export const getAddressData = (
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  return (
    addresses?.find((address) => address.address_type === addressType) ||
    getAddressFields(addressType)
  );
};

export function getRelation(relationValue?: string | null): boolean {
  return ['Mother', 'Father', 'Daughter', 'Son', 'Spouse', 'Brother', 'Sister', ''].includes(
    relationValue || ''
  );
}

export const saveForLater = (
  role: string,
  id?: string,
  applicant1ReferenceId?: string | null,
  isTopUp?: boolean | null
): string => {
  return role === USER_ROLES.INVESTOR
    ? `/${isTopUp ? 'topup' : 'investment-details'}/${applicant1ReferenceId}/application-details`
    : role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER
    ? `/application-details/${id}`
    : isTopUp
    ? '/view-top-up-list'
    : '/applications';
};

export const maxAge = (dateOfBirth = ''): boolean => {
  const thisYear = new Date().getFullYear();
  return thisYear - new Date(dateOfBirth).getFullYear() > 125;
};
export const futureAge = (dateOfBirth = ''): boolean => {
  return new Date(dateOfBirth) > new Date();
};
export function currencyConversion(
  num?: string | number | null,
  currencyType?: string | null
): string | null {
  if (!num) return '';
  const toWords = new ToWords({
    localeCode: Object.keys(CurrencyMaster).includes(currencyType?.toLowerCase() || '')
      ? CurrencyMaster[currencyType?.toLowerCase() || defaultCurrency]?.localeCode
      : CurrencyMaster[defaultCurrency]?.localeCode,
  });
  const words = toWords.convert(Number(num), { currency: true });
  return words;
}

export const isOnboardingTypeMinor = (onBoardingType: string): boolean => {
  return onboardingTypeMasters[onBoardingType] === onboardingTypeMasters.minor;
};

export const isFatherMother = (guardianRelationship: string): boolean => {
  return ['MOTHER', 'FATHER'].includes(guardianRelationship);
};

export function checkIfApplicationIsNonIndividual({ applicationType }: ApplicationProps): boolean {
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL;
}

// eslint-disable-next-line
export const preventSpecialCharacters = (e: any): void => {
  if (
    !((e.ctrlKey || e.metaKey) && e.keyCode == 67) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 86) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 88) &&
    !((e.ctrlKey || e.metaKey) && e.keyCode == 90) &&
    !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Enter', 'Tab'].includes(e.key) &&
    !numberRegex.test(e.key)
  ) {
    e.preventDefault();
  }
};
// eslint-disable-next-line
export function allowOnlyNumbers(e: any): void {
  if (['-', '+', 'e', 'E'].includes(e.key)) {
    e.preventDefault();
  }
}
export const permanentAddressSameAsCorresponding = (
  updatedCorrespondingAddress: Partial<ApplicantAddressType>,
  addressType: string,
  addresses: Partial<ApplicantAddressType>[] | undefined
): Partial<ApplicantAddressType> => {
  // eslint-disable-next-line
  const { address1, address2, city, pincode, state, country, ...rest } =
    updatedCorrespondingAddress;
  return {
    ...getAddressData(addressType, addresses),
    address1: address1,
    address2: address2,
    city: city,
    pincode: pincode,
    state: state,
    country: country,
    address_type: addressType,
  };
};
export const _updatedAddresses = (
  updatedAddresses: {
    nationality?: string | null | undefined;
    status?: string | null | undefined;
    permanent?: Partial<ApplicantAddressType> | undefined;
    correspondence?: Partial<ApplicantAddressType> | undefined;
    overseas?: Partial<ApplicantAddressType> | undefined;
    [key: string]: string | Partial<ApplicantAddressType> | null | undefined;
  },
  applicant: Partial<Applicant>
): Partial<ApplicantAddressType>[] => {
  // eslint-disable-next-line
  const { nationality, status, ...addressProps } = updatedAddresses;
  return Object.keys(addressProps)
    .map((addressType) => {
      // if (applicant.nationality?.toLowerCase() === 'indian' && addressType === 'overseas') {
      //   return {};
      // }
      if (
        addressType === 'permanent' &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['overseas'],
          addressType,
          applicant.addresses
        );
      }
      if (
        addressType === 'permanent' &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding &&
        !addressProps['overseas']
      ) {
        return permanentAddressSameAsCorresponding(
          addressProps['correspondence'],
          addressType,
          applicant.addresses
        );
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['overseas']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['overseas'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      if (
        Object.keys(addressProps).length === 1 &&
        addressProps['correspondence']?.permanentAddressSameAsCorresponding
      ) {
        return [
          {
            ...permanentAddressSameAsCorresponding(
              addressProps['correspondence'],
              'permanent',
              applicant.addresses
            ),
          },
          {
            ...getAddressData(addressType, applicant.addresses),
            ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
            address_type: addressType,
          },
        ];
      }
      return {
        ...getAddressData(addressType, applicant.addresses),
        ...(addressProps[addressType] as unknown as Partial<ApplicantAddressType>),
        address_type: addressType,
      };
    })
    .flat()
    .filter((address) => Object.keys(address).length);
};
export const applyRoleBasedStatus = (role: USER_ROLES): boolean => {
  return [
    USER_ROLES.RM,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.AMCAPPROVER,
    USER_ROLES.AMC_ADMIN,
  ].includes(role);
};

export const checkKraBasedOnStatus = (status: string): boolean => {
  return ![
    APPLICATION_LISTING_STATUS.invitationexpired,
    APPLICATION_LISTING_STATUS.signed,
    APPLICATION_LISTING_STATUS.completed,
    APPLICATION_LISTING_STATUS.rejected,
  ].includes(APPLICATION_LISTING_STATUS[status]);
};

export const applicationComparison = (
  existingApplication: Partial<ApplicationProps> | Partial<KycApplicationResponse> | null,
  updatedApplication: Partial<ApplicationProps> | Partial<KycApplicationResponse>
): boolean => {
  return _.isEqual(existingApplication, updatedApplication);
};

export const sendApplication_Nri = (application?: ApplicationProps | null): boolean | undefined => {
  return application?.applicants.map((applicant) => applicant.status).includes('NRI');
};

export const checkForCorrespondenceAddress = (
  nationality: string | null | undefined,
  status: string | null | undefined
): boolean => {
  return (
    nationality?.toLowerCase() === 'indian' &&
    applicantStatusMasters[status as string] === applicantStatusMasters.Individual
  );
};

export const setUpFeeCalculations = (
  commitmentAmount: number,
  setupFeePercentage: number
): { feeAmount: number; feeGst: number; totalSetupFee: number } => {
  const setupFeeAmount = (Number(commitmentAmount) * Number(setupFeePercentage)) / 100;
  const GstForSetupFee = (setupFeeAmount * 18) / 100;
  return {
    feeAmount: Number(setupFeeAmount.toFixed(2)),
    feeGst: Number(GstForSetupFee.toFixed(2)),
    totalSetupFee: Number((setupFeeAmount + GstForSetupFee).toFixed(2)),
  };
};

export const checkAddressField = (data?: string): string => {
  if (data) {
    if (data.includes(' ,')) {
      return data.split(' ,').join(',') + ' ';
    }
    return data.includes(',') ? data + ' ' : data + ', ';
  }
  return '';
};

export const getdpIdField = (value: string): boolean => {
  return (
    DLCLMasters[value || ''] === DLCLMasters.cdsl || DLCLMasters[value || ''] === DLCLMasters.nsdl
  );
};

export const clearclIdField = (value: string): boolean => {
  return (
    DLCLMasters[(value as string) || ''] === DLCLMasters.none ||
    DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl
  );
};

export const cleardpIdField = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.none;
};

export const getclIdField = (value: string): boolean => {
  return DLCLMasters[value || ''] === DLCLMasters.nsdl;
};

export const isCDSL = (value: string): boolean => {
  return DLCLMasters[(value as string) || ''] === DLCLMasters.cdsl;
};

export const getBankAddress = (
  address1: string | undefined,
  address2: string | undefined,
  address3: string | undefined
): string => {
  return `${address2 ? checkAddressField(address1) || '' : address1 || '' || ''}${
    address3 ? checkAddressField(address2) || '' : address2 || ''
  }${address3 || ''}`;
};
// eslint-disable-next-line
export const numToAlpMonth = (numMonth: any, month: any) => {
  // eslint-disable-next-line
  numMonth?.map((monthNum: any) => {
    if (monthNum === 1) {
      month.push('Jan');
    } else if (monthNum === 2) {
      month.push('Feb');
    } else if (monthNum === 3) {
      month.push('Mar');
    } else if (monthNum === 4) {
      month.push('Apr');
    } else if (monthNum === 5) {
      month.push('May');
    } else if (monthNum === 6) {
      month.push('Jun');
    } else if (monthNum === 7) {
      month.push('Jul');
    } else if (monthNum === 8) {
      month.push('Aug');
    } else if (monthNum === 9) {
      month.push('Sep');
    } else if (monthNum === 10) {
      month.push('Oct');
    } else if (monthNum === 11) {
      month.push('Nov');
    } else if (monthNum === 12) {
      month.push('Dec');
    }
  });
};
// eslint-disable-next-line
export const removeSingleQuote = (value: string | null | undefined): any => {
  if (value && value.includes("'")) return value.split("'").join('');
  else return value;
};

export function removeEqualOperator(value = ''): string {
  const lastTwoIndex = value.length - 2;
  let encodeString = value.slice(0, lastTwoIndex);
  const slicedStr = value.slice(lastTwoIndex, value.length);
  slicedStr.split('').forEach((char) => {
    if (char !== '=') {
      encodeString += char;
    }
  });
  return encodeString;
}

export function encodeBase64(value: string): string {
  const encodeValue = btoa(value);
  const encodeSubString = removeEqualOperator(encodeValue);
  const encodePayload = btoa(`${SALT}${encodeSubString}${SALT2}`);
  return encodePayload;
}

export function getNomineeRelation(relationValue?: string | null): boolean {
  return [
    'Mother',
    'Father',
    'Friend',
    'Son',
    'Spouse',
    'Brother',
    'Sister',
    'Daughter',
    'Niece',
    'Nephew',
    'Aunt',
    'Uncle',
    'Grand Father',
    'Grand Mother',
    'Grand Son',
    'Grand Daughter',
    'Son-in-law',
    'Daughter-in-law',
    '',
  ]
    .map((relation) => relation.toUpperCase())
    .includes(relationValue || '');
}

export function updatedCommitmentAmount(
  minCommitmentAmount: number,
  applicants: Partial<Applicant>[],
  data: JointholderRelationMaster
): number | void {
  const minbySebi = 10000000;
  if (applicants.length === 2) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele)
      ?.toString();
    const relation = BloodRelations.includes(
      ['Wife', 'Husband'].includes(applicantRelation) ? 'Spouse' : applicantRelation
    )
      ? applicantRelation
      : 'Others';
    const amount = data.singleJointHolder
      .map((jointHolder) => {
        if (jointHolder.jointHolder1RelationShip === relation) {
          return (minbySebi * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Math.max(Number(amount), minCommitmentAmount);
  }
  if (applicants.length === 3) {
    const applicantRelation = applicants
      .map((applicant) => applicant.relationShipWithFirstApplicant)
      .filter((ele) => ele);
    const relation = applicantRelation.map((_relation) =>
      BloodRelations.includes(
        ['Wife', 'Husband'].includes(_relation || '') ? 'Spouse' : (_relation as string)
      )
        ? _relation
        : 'Others'
    );
    const amount = data.twoJointHolders
      .map((jointHolder) => {
        if (
          relation[applicants.length - 3] === jointHolder.jointHolder1RelationShip &&
          relation[applicants.length - 2] === jointHolder.jointHolder2RelationShip
        ) {
          return (minbySebi * jointHolder.minimumAmountPercentage) / 100;
        }
      })
      .filter((ele) => ele)
      .toString();
    return Math.max(Number(amount), minCommitmentAmount);
  }
}

export function applicationDownloadStatusCheck(status: string): boolean {
  return APPLICATION_LISTING_STATUS[status] !== APPLICATION_LISTING_STATUS.completed;
}

export const checkUBOTypeIsTrust = (typeOfUBO: string): boolean => {
  return [UboTypeMaster.notApplicable, UboTypeMaster.indeterminateTrust].includes(
    UboTypeMaster[typeOfUBO]
  );
};

export const isValidPan = (pan: string): boolean =>
  [individualPanRegex, nonIndividualPanRegex].some((pattern) => pattern.test(pan));

export const getArrayLength = (arrayList: number): number[] => {
  return Array.from(
    {
      length: arrayList,
    },
    (value, index) => index + 1
  );
};

export function checkIfApplicationIsNonIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL && hasPOA;
  } else return false;
}

export function isJson(str: string): boolean {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

export const checkValidationBasedOnDate = (
  date: string | number | Date,
  validationStartDate: string
): boolean => {
  if (!date) return false;
  if (!validationStartDate) return true;
  const dateForCompare = date ? new Date(date) : new Date();
  const dateForApplyValidations = new Date(validationStartDate || '');
  return dateForCompare.getTime() >= dateForApplyValidations.getTime();
};

export const checkNriPIO = (status: string, statusSubType: string): boolean => {
  return (
    applicantStatusMasters[status as string] === applicantStatusMasters.NRI &&
    applicantStatusMasters[statusSubType as string] === applicantStatusMasters.NRI_PIO
  );
};

export const checkNormalNri = (status: string, statusSubType?: string | null): boolean => {
  return applicantStatusMasters[status as string] === applicantStatusMasters.NRI && !statusSubType;
};

export const getCountryBasedOnStatus = (
  nationalitiesMdmsResponse: mdmsCountriesList[],
  status: string
): mdmsCountriesList[] => {
  return nationalitiesMdmsResponse.filter((ele) => {
    if (applicantStatusMasters[status] === applicantStatusMasters.NRI_PIO) {
      return !['PK', 'NP', 'AF', 'BD', 'CN', 'IQ', 'BT', 'LK'].includes(ele.code || '');
    }
    return ele;
  });
};

export const getSideNavComponent = (
  navOptions: string[],
  createdAt: string,
  toggler: togglerType
): string[] => {
  let _navOptions: string[] = navOptions;
  _navOptions = !RiskProfileEnabled
    ? _navOptions.filter((e) => !['risk-profiles', 'Risk Profiles'].includes(e))
    : _navOptions;
  _navOptions = checkValidationBasedOnDate(
    createdAt,
    toggler?.dateFeatureToggles?.nomineeRemovalAndDeclarationValidationDate || ''
  )
    ? _navOptions.filter((e) => !['nominee-details', 'Nominee Details'].includes(e))
    : _navOptions;
  return _navOptions;
};

export const ShowRiskDoc = (documentType: string): boolean => {
  return ['riskProfile', 'riskDeviationLetter', 'riskDisclosure'].includes(documentType);
};

export const RTAApproverEnableCheckForIndividual = (): boolean =>
  ENABLE_RTA_APPROVER && AMC_APPROVER_CHECK_FOR_INDIVIDUAL;

export const ApplicationStatusOrClassBasedOnRole = (
  application: ApplicationProps,
  role: USER_ROLES
): string => {
  return application.hasPOA || checkIfApplicationIsNonIndividual(application)
    ? [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER, USER_ROLES.POAAPPROVER].includes(role)
      ? ApplicationStatusBasedOnRole[role][application.status]
      : APPLICATION_LISTING_STATUS[application.status]
    : !checkIfApplicationIsNonIndividual(application) &&
      [USER_ROLES.AMCAPPROVER, USER_ROLES.RTAAPPROVER].includes(role)
    ? IndividualApplicationStatusBasedOnRole[role][application.status]
    : APPLICATION_LISTING_STATUS[application.status];
};

export const MakerOrAdmin = (role: USER_ROLES): boolean =>
  [USER_ROLES.AMC_ADMIN, USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(
    role
  );

export const RTAApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.RTAAPPROVER;
export const AMCApproverLoggedIn = (role: USER_ROLES): boolean => role === USER_ROLES.AMCAPPROVER;

export const Maker = (role: USER_ROLES): boolean =>
  [USER_ROLES.RM, USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role);

export const statusRoleBased = (role: USER_ROLES, application: ApplicationProps | null): string => {
  return Maker(role) &&
    (application?.applicationType === APPLICATION_TYPE.NON_INDIVIDUAL ||
      AMC_APPROVER_CHECK_FOR_INDIVIDUAL)
    ? 'draft'
    : application?.status || '';
};

export const isRtaSendBackToMaker = (value?: string): boolean => value === 'maker';

export const isGetLinkVisible = (status: string): boolean =>
  ![
    'draft',
    'rejected',
    'sent_to_poa_approver',
    'sent_to_amc_approver',
    'sent_to_rta_approver',
  ].includes(status);

export const displaySendBack = (application: ApplicationProps): string => {
  return application.applicationSentBack ||
    (application.rtaSentBack &&
      APPLICATION_LISTING_STATUS[application.status] ===
        APPLICATION_LISTING_STATUS.sent_to_amc_approver)
    ? '(Send Back)'
    : '';
};

export function checkIfApplicationIsIndividualPOA(application: ApplicationProps): boolean {
  if (application) {
    const { applicationType, hasPOA } = application;
    return applicationType === APPLICATION_TYPE.INDIVIDUAL && hasPOA;
  } else return false;
}

export function shouldValidateUponSaveLater(saveType: string): boolean {
  return (
    (saveType === 'save for later' && SAVE_LATER_VALIDATION_CHECK) || saveType !== 'save for later'
  );
}

export function getStep(currentStep: number, isSaveLater: boolean): number {
  return !SAVE_LATER_VALIDATION_CHECK && isSaveLater ? currentStep - 1 : currentStep;
}

export function otherNameOfBroker(nameOfBroker: string): boolean {
  return nameOfBroker?.toLocaleLowerCase() === 'others';
}

export function nameOfBrokerExists(brokerList: Broker[], nameOfBroker: string): boolean {
  return brokerList?.map((broker) => broker.key).includes(nameOfBroker || '');
}

export const sortListKeepOthersLast = (brokerList: Broker[] = []): Broker[] => {
  // Separate "Others" from the rest of the items
  const others = brokerList.filter((item) => item.key === 'others');
  const rest = brokerList
    .filter((item) => item.key !== 'others')
    .sort((a, b) => a.key?.localeCompare(b.key));

  // Sort the rest of the items and append "Others" at the end
  return [...rest.sort(), ...others];
};

export function isAccreditedInvestorApplicable(accreditedInvestorApplicable: string): boolean {
  return accreditedInvestorApplicable?.toLowerCase() === 'yes';
}

export function isFieldApplicable(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  return YES_NO_MASTER[value.toLowerCase()] === YES_NO_MASTER.yes;
}

export function isFieldVariable(FeeTypeValue: string | null, fieldApplicable: string): boolean {
  if (typeof FeeTypeValue !== 'string' || typeof fieldApplicable !== 'string') return false;
  return (
    FEE_TYPE_MASTER[FeeTypeValue?.toLowerCase() || ''] === FEE_TYPE_MASTER.variable &&
    YES_NO_MASTER[fieldApplicable?.toLowerCase()] === YES_NO_MASTER.yes
  );
}

export function isFieldValueFixed(FeeTypeValue: string | null, fieldApplicable: string): boolean {
  return (
    FEE_TYPE_MASTER[FeeTypeValue?.toLowerCase() || ''] === FEE_TYPE_MASTER.fixed &&
    YES_NO_MASTER[fieldApplicable?.toLowerCase()] === YES_NO_MASTER.yes
  );
}

export function isFieldValueInWords(FeeTypeValue: string | null, fieldApplicable: string): boolean {
  return (
    FEE_TYPE_EXTENDED_MASTER[FeeTypeValue?.toLowerCase() || ''] === FEE_TYPE_EXTENDED_MASTER.word &&
    YES_NO_MASTER[fieldApplicable?.toLowerCase()] === YES_NO_MASTER.yes
  );
}

export const isApplicationStatusComplete = (application: ApplicationProps): boolean => {
  return (
    APPLICATION_LISTING_STATUS[application?.status] === APPLICATION_LISTING_STATUS.completed &&
    !!Number(application.folio_no || application.xalt_folio_no)
  );
};

export const checkSupportLogin = (createdBy: string | number, id: string | number): boolean => {
  return Number(createdBy) === Number(id);
};

export const checkSubDisDisable = (
  role: USER_ROLES,
  createdBy: string | number,
  id: string | number
): boolean => {
  return (
    [
      USER_ROLES.DISTRIBUTOR,
      USER_ROLES.INVESTOR,
      USER_ROLES.POAAPPROVER,
      USER_ROLES.AMCAPPROVER,
      USER_ROLES.RTAAPPROVER,
      USER_ROLES.AMC_ADMIN,
    ].includes(role) ||
    (USER_ROLES.SUBDISTRIBUTOR === role && !checkSupportLogin(Number(createdBy), Number(id)))
  );
};

/**
 * Replace with your file URL or API endpoint
 * @param fileUrl
 *
 * Desired file name
 * @param fileName
 */
export const handleDownload = async (fileUrl: string, fileName: string): Promise<void> => {
  try {
    const url = new URL(fileUrl, window.location.origin);

    const isSameOrigin = url.origin === window.location.origin;

    if (isSameOrigin) {
      // Same-origin: rename supported
      const response = await fetch(fileUrl);

      if (!response.ok) {
        throw new Error('Unable to download file');
      }

      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      link.remove();
      URL.revokeObjectURL(blobUrl);
    } else {
      // Cross-origin (e.g. S3): no fetch => no CORS issue
      const link = document.createElement('a');
      link.href = fileUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';

      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  } catch (error) {
    console.error('Download failed:', error);
    throw error;
  }
};

export const isApplicantsVerified = (application: ApplicationProps): boolean => {
  return !application.applicants.some((applicant) => applicant.kraVerified === 'no');
};

export const decodeState = (
  stateValue = ''
): null | { digiLockerAmcCode: string; esignReferenceId: string; token: string; role: string } => {
  if (!stateValue) return null;
  return JSON.parse(atob(stateValue));
};

export const roleApplicableForKycPreview = (role: USER_ROLES): boolean =>
  [
    USER_ROLES.AMC_ADMIN,
    USER_ROLES.RM,
    USER_ROLES.DISTRIBUTOR,
    USER_ROLES.SUBDISTRIBUTOR,
    USER_ROLES.INVESTOR,
  ].includes(role);

export const ifPushToXalt = (value: string): boolean => {
  return [KBOLT_XALT_MASTER.XALT, KBOLT_XALT_MASTER.KBOLT_XALT].includes(value);
};
export function getDocNumberForMultipleDocs(docArraylength: number): string | null {
  switch (docArraylength.toString()) {
    case '1':
      return 'first ';
    case '2':
      return 'second ';
    case '3':
      return 'third ';
    case '4':
      return 'forth';
    default:
      return '';
  }
}

export const nonIndividualDocuments = (
  application: ApplicationProps | null,
  role: USER_ROLES,
  documentsData: individuals_Poa_nonIndividuals_Documents[]
): nonIndDocumentProps[] => {
  const { applicants = [], isPhysicalApplication, isTopup, banks } = application || {};
  return applicants.map((applicant, applicant_index) => {
    return {
      documents: documentsData
        .filter((doc) => {
          if (
            checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) &&
            applicant.applicant_type !== '1' &&
            doc.documentType === 'poaNotarized'
          ) {
            return;
          }
          if (!RiskProfileEnabled && ShowRiskDoc(doc.documentType)) {
            return;
          }
          if (
            !application?.isAccreditedInvestor &&
            doc.documentType === 'accreditation_certificate'
          ) {
            return;
          }
          return doc;
        })
        .filter((ele) => ele)
        .map((_doc) => {
          if (role === USER_ROLES.POAAPPROVER && _doc.documentType === 'poaNotarized') {
            return { ..._doc, required: 'true' };
          }
          if (RiskProfileEnabled && ShowRiskDoc(_doc.documentType)) {
            return { ..._doc, required: 'true' };
          }
          if (
            application?.isAccreditedInvestor &&
            _doc.documentType === 'accreditation_certificate'
          ) {
            return { ..._doc, required: 'true' };
          }
          if (_doc.documentType === 'bankAccountProof' && banks?.length) {
            if (
              banks?.filter(
                (bank) => !bank.pennydropVerified && bank.defaultBankAccount && !bank?.isTopup
              ).length !== 0 &&
              applicant_index === 0
            ) {
              return { ..._doc, required: 'true' };
            }
          }
          return _doc;
        })
        .filter((document) => {
          if (applicant.amlCheck && document.documentType === 'compliance_document') {
            return;
          }
          return document;
        })
        .filter((ele) => ele)
        .map((_doc) => {
          if (
            applicant?.dlclId &&
            !cleardpIdField(applicant?.dlclId || '') &&
            _doc.documentType === 'demat_information'
          ) {
            return { ..._doc, required: 'true' };
          }
          return _doc;
        })
        .map((doc) => {
          if (isPhysicalApplication || isTopup) return { ...doc, required: 'false' };
          return doc;
        })
        .map((doc, index) => {
          const { documentType, documentName, multipleFiles, required, options } = doc;
          const { documents: existingDocuments = [] } = applicant || {};
          const docsOfCurrentDocType = existingDocuments
            .filter((doc) => doc.documentType === documentType)
            .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
          return {
            documentType: documentType,
            documentName: documentName,
            documentsList: docsOfCurrentDocType.length
              ? docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    id,
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                  } = doc;
                  const isApplicant = Object.keys(doc).includes('applicantId');

                  return {
                    id,
                    [isApplicant ? 'applicantId' : 'topupApplicantId']: application?.topupInitiated
                      ? isApplicant
                        ? applicant?.applicantId
                        : applicant?.id
                      : applicant?.id,
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    options,
                    required,
                    isVisible: true,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                    errorOnUpload: document_object.errorOnUpload,
                  };
                })
              : [
                  {
                    documentType,
                    documentName,
                    required,
                    options,
                    isVisible: true,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  },
                ],
            required,
            multipleFiles,
            options,
          };
        }),
      kraDocument: applicant.kraDocument,
    };
  });
};

export const individualDocuments = (
  application: ApplicationProps | null,
  role: USER_ROLES,
  documentsData?: Document | string
): documentProps[] => {
  const {
    applicants = [],
    hasPOA = false,
    isPhysicalApplication,
    isTopup,
    banks,
  } = application || {};
  return applicants.map((applicant, applicant_index) => {
    let docData = '';
    if (
      !hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      if (
        onboardingTypeMasters[applicants[0].onboardingType as string] ===
        onboardingTypeMasters.minor
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
      } else {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      }
    }
    if (
      hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
    }
    if (!hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
    }
    if (hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
    }
    if (!hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_PIO;
    }
    if (hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA_PIO;
    }
    return {
      documents:
        typeof documentsData !== 'undefined'
          ? ((documentsData as Document)[docData] || [])
              .filter((doc) => {
                if (
                  hasPOA &&
                  applicant.applicant_type !== '1' &&
                  doc.documentType === 'poaNotarized'
                ) {
                  return;
                }
                if (
                  isNaturalParent[applicant.naturalParent as string] !== isNaturalParent.no &&
                  doc.documentType === 'proofOfCourt'
                ) {
                  return;
                }
                if (!RiskProfileEnabled && ShowRiskDoc(doc.documentType)) {
                  return;
                }
                if (
                  !application?.isAccreditedInvestor &&
                  doc.documentType === 'accreditation_certificate'
                ) {
                  return;
                }
                if (
                  application?.isAccreditedInvestor &&
                  !isFirstApplicant(applicant?.applicant_type || '') &&
                  doc.documentType === 'accreditation_certificate'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((_doc) => {
                if (role === USER_ROLES.POAAPPROVER && _doc.documentType === 'poaNotarized') {
                  return { ..._doc, required: 'true' };
                }
                if (
                  isNaturalParent[applicant.naturalParent as string] === isNaturalParent.no &&
                  _doc.documentType === 'proofOfCourt'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (RiskProfileEnabled && ShowRiskDoc(_doc.documentType)) {
                  return { ..._doc, required: 'true' };
                }
                if (
                  application?.isAccreditedInvestor &&
                  isFirstApplicant(applicant?.applicant_type || '') &&
                  _doc.documentType === 'accreditation_certificate'
                ) {
                  return { ..._doc, required: 'true' };
                }
                if (_doc.documentType === 'bankAccountProof' && banks?.length) {
                  if (
                    banks?.filter(
                      (bank) => !bank.pennydropVerified && bank.defaultBankAccount && !bank?.isTopup
                    ).length !== 0 &&
                    applicant_index === 0
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                }
                return _doc;
              })
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document') {
                  return;
                }
                return document;
              })
              .filter((ele) => ele)
              .filter((doc) => {
                if (
                  !applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return;
                }
                return doc;
              })
              .filter((ele) => ele)
              .map((doc) => {
                if (
                  applicant.correspondenceAddressEdited &&
                  doc.documentType === 'correspondenceAddress'
                ) {
                  return { ...doc, required: 'true' };
                }
                return doc;
              })
              .map((_doc) => {
                if (
                  applicant?.dlclId &&
                  !cleardpIdField(applicant?.dlclId || '') &&
                  isFirstApplicant(applicant?.applicant_type || '') &&
                  _doc.documentType === 'demat_information'
                ) {
                  return { ..._doc, required: 'true' };
                }
                return _doc;
              })
              .map((doc) => {
                if (isPhysicalApplication || isTopup) return { ...doc, required: 'false' };
                return doc;
              })
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType && !doc?.isTopup)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                        const {
                          id,
                          documentName = '',
                          documentType = '',
                          documentId = '',
                          isActive = true,
                          file = undefined,
                        } = doc;
                        const isApplicant = Object.keys(doc).includes('applicantId');
                        return {
                          id,
                          [isApplicant ? 'applicantId' : 'topupApplicantId']:
                            application?.topupInitiated
                              ? isApplicant
                                ? applicant?.applicantId
                                : applicant?.id
                              : applicant?.id,
                          documentType,
                          documentName,
                          documentId,
                          isActive,
                          file,
                          options,
                          required,
                          isVisible: true,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            ind.toString()) as string,
                          errorOnUpload: document_object.errorOnUpload,
                        };
                      })
                    : [
                        {
                          documentType,
                          documentName,
                          required,
                          options,
                          isVisible: true,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '0') as string,
                          ...document_object,
                        },
                      ],
                  required,
                  multipleFiles,
                  options,
                };
              })
          : [],
      kraDocument: applicant.kraDocument,
    };
  });
};

export const nomineesDocuments = (
  application: ApplicationProps | null,
  documentsData?: Document | string
): nomineeDocumentProps[] => {
  const { nominees = [], isPhysicalApplication, isTopup } = application || {};
  return nominees.map((nominee, nominee_index) => {
    return {
      nomineedocuments:
        typeof documentsData !== 'undefined'
          ? (isMinor(nominee.dateOfBirth || '')
              ? [
                  ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                    []),
                  ...((documentsData as Document)[
                    APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                  ] || []),
                ].map((doc) => {
                  if (doc.documentType === 'nomineeIdProof') {
                    return { ...doc, required: 'false' };
                  }
                  return doc;
                })
              : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
            )
              .map((doc) => {
                if (isPhysicalApplication || isTopup) return { ...doc, required: 'false' };
                return doc;
              })
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { nomineedocuments: existingDocuments = [] } = nominee || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                        const {
                          id,
                          documentName = '',
                          documentType = '',
                          documentId = '',
                          isActive = true,
                          file = undefined,
                        } = doc;
                        return {
                          id,
                          nomineeId: nominee?.id,
                          documentType,
                          documentName,
                          documentId,
                          isActive,
                          file,
                          options,
                          required,
                          isVisible: true,
                          uniqueKey: (nominee_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            ind.toString()) as string,
                          errorOnUpload: document_object.errorOnUpload,
                        };
                      })
                    : [
                        {
                          documentType,
                          documentName,
                          required,
                          options,
                          isVisible: true,
                          uniqueKey: (nominee_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '0') as string,
                          ...document_object,
                        },
                      ],
                  required,
                  multipleFiles,
                  options,
                };
              })
          : [],
    };
  });
};

/**
 * Partition an array of Bank objects into two separate arrays, one for non-topup banks and one for topup banks.
 * @param array The array of Bank objects to partition.
 * @returns An array of two arrays, the first containing non-topup banks and the second containing topup banks.
 */
export const partitionArray = (array: Partial<Bank>[]): Partial<Bank>[][] => {
  return array.reduce(
    ([pass, fail]: Partial<Bank>[][], elem) => {
      return elem?.isTopup ? [[...pass, elem], fail] : [pass, [...fail, elem]];
    },
    [[], []]
  );
};

export const makeStringInSingleLine = (str: string): string => {
  return String(str)?.replace(/(\r\n|\n|\r)/gm, ' ');
};

export const UpdatedTopUpValues = (values: topUpPlanType): topUpPlanType => {
  const {
    isTopupApplicable,
    topUpSetupFeeApplicable,
    topUpSetupFeeType,
    topUpMaxSetupFee,
    topUpMinSetupFee,
    topUpSetupFee,
    topUpSetupFeeInWords,
    topUpOtherSetUpFeeApplicable,
    topUpMaxCommitmentAmount,
    topUpMinCommitmentAmount,
    topUpMinContributionPercentage,
    topUpAccreditedInvestorApplicable,
    topUpAccreditedMinCommitmentAmount,
    topUpManagementFeeApplicable,
    topUpManagementFeeType,
    topUpMaxManagementFee,
    topUpMinManagementFee,
    defaultTopUpManagementFee,
    topUpHurdleRateApplicable,
    topUpHurdleRateType,
    topUpMaxHurdleRate,
    topUpMinHurdleRate,
    defaultTopUpHurdleRate,
    topUpPerformanceFeeApplicable,
    topUpPerformanceFeeType,
    topUpMinPerformanceFee,
    topUpMaxPerformanceFee,
    defaultTopUpPerformanceFee,
    topUpExitChargeApplicable,
    topUpExitChargeType,
    topUpMaxExitCharge,
    topUpMinExitCharge,
    defaultTopUpExitCharge,
    topUpPlacementFeeApplicable,
    topUpPlacementFeeType,
    topUpMaxPlacementFee,
    topUpMinPlacementFee,
    defaultTopUpPlacementFee,
    topUpOperatingExpenseApplicable,
    topUpOperatingExpenseType,
    topUpMaxOperatingExpense,
    topUpMinOperatingExpense,
    defaultTopUpOperatingExpenses,
    topupExitLoad,
    topupAdditionalReturnApplicable,
    topupAdditionalReturnType,
    topupDefaultAdditionalReturn,
    topupMinAdditionalReturn,
    topupMaxAdditionalReturn,
    topupExitLoadDetails,
    topupExitLoadDetailsApplicable,
    topupOperatingExpenseInWords,
    topupCarryShareApplicable,
    topupCarryShareType,
    topupCarryShare,
    topupMinCarryShare,
    topupMaxCarryShare,
    topupContributionAmtApplicable,
    topupExitLoadDetailsType,
  } = values;
  try {
    return isTopupApplicable
      ? {
          isTopupApplicable,
          topUpSetupFeeApplicable,
          topUpSetupFeeType: isFieldApplicable(topUpSetupFeeApplicable) ? topUpSetupFeeType : null,
          topUpMaxSetupFee: isFieldVariable(topUpSetupFeeType, topUpSetupFeeApplicable)
            ? topUpMaxSetupFee
            : null,
          topUpMinSetupFee: isFieldVariable(topUpSetupFeeType, topUpSetupFeeApplicable)
            ? topUpMinSetupFee
            : null,
          topUpSetupFee:
            isFieldVariable(topUpSetupFeeType, topUpSetupFeeApplicable) ||
            isFieldValueFixed(topUpSetupFeeType, topUpSetupFeeApplicable)
              ? topUpSetupFee
              : 0,
          topUpSetupFeeInWords: isFieldValueInWords(topUpSetupFeeType, topUpSetupFeeApplicable)
            ? makeStringInSingleLine(topUpSetupFeeInWords || '')
            : null,
          topUpOtherSetUpFeeApplicable:
            isFieldVariable(topUpSetupFeeType, topUpSetupFeeApplicable) ||
            isFieldValueFixed(topUpSetupFeeType, topUpSetupFeeApplicable)
              ? topUpOtherSetUpFeeApplicable
              : '',
          topUpMinCommitmentAmount,
          topUpMaxCommitmentAmount,
          topUpMinContributionPercentage: isFieldApplicable(topupContributionAmtApplicable)
            ? topUpMinContributionPercentage
              ? topUpMinContributionPercentage
              : 0
            : null,
          topUpAccreditedInvestorApplicable,
          topUpAccreditedMinCommitmentAmount: isAccreditedInvestorApplicable(
            topUpAccreditedInvestorApplicable
          )
            ? topUpAccreditedMinCommitmentAmount
            : null,
          topUpManagementFeeApplicable,
          topUpManagementFeeType: isFieldApplicable(topUpManagementFeeApplicable)
            ? topUpManagementFeeType
            : null,
          defaultTopUpManagementFee: isFieldApplicable(topUpManagementFeeApplicable)
            ? defaultTopUpManagementFee
            : 0,
          topUpMaxManagementFee: isFieldVariable(
            topUpManagementFeeType,
            topUpManagementFeeApplicable
          )
            ? topUpMaxManagementFee
            : null,
          topUpMinManagementFee: isFieldVariable(
            topUpManagementFeeType,
            topUpManagementFeeApplicable
          )
            ? topUpMinManagementFee
            : null,
          topUpHurdleRateApplicable,
          defaultTopUpHurdleRate: isFieldApplicable(topUpHurdleRateApplicable)
            ? defaultTopUpHurdleRate
            : null,
          topUpHurdleRateType: isFieldApplicable(topUpHurdleRateApplicable)
            ? topUpHurdleRateType
            : null,
          topUpMaxHurdleRate: isFieldVariable(topUpHurdleRateType, topUpHurdleRateApplicable)
            ? topUpMaxHurdleRate
            : null,
          topUpMinHurdleRate: isFieldVariable(topUpHurdleRateType, topUpHurdleRateApplicable)
            ? topUpMinHurdleRate
            : null,
          topUpPerformanceFeeApplicable,
          defaultTopUpPerformanceFee: isFieldApplicable(topUpPerformanceFeeApplicable)
            ? defaultTopUpPerformanceFee
            : null,
          topUpPerformanceFeeType: isFieldApplicable(topUpPerformanceFeeApplicable)
            ? topUpPerformanceFeeType
            : null,
          topUpMaxPerformanceFee: isFieldVariable(
            topUpPerformanceFeeType,
            topUpPerformanceFeeApplicable
          )
            ? topUpMaxPerformanceFee
            : null,
          topUpMinPerformanceFee: isFieldVariable(
            topUpPerformanceFeeType,
            topUpPerformanceFeeApplicable
          )
            ? topUpMinPerformanceFee
            : null,
          topUpExitChargeApplicable,
          defaultTopUpExitCharge: isFieldApplicable(topUpExitChargeApplicable)
            ? defaultTopUpExitCharge
            : null,
          topUpExitChargeType: isFieldApplicable(topUpExitChargeApplicable)
            ? topUpExitChargeType
            : null,
          topUpMaxExitCharge: isFieldVariable(topUpExitChargeType, topUpExitChargeApplicable)
            ? topUpMaxExitCharge
            : null,
          topUpMinExitCharge: isFieldVariable(topUpExitChargeType, topUpExitChargeApplicable)
            ? topUpMinExitCharge
            : null,
          topUpPlacementFeeApplicable,
          topUpPlacementFeeType: isFieldApplicable(topUpPlacementFeeApplicable)
            ? topUpPlacementFeeType
            : null,
          defaultTopUpPlacementFee: isFieldApplicable(topUpPlacementFeeApplicable)
            ? defaultTopUpPlacementFee
            : 0,
          topUpMaxPlacementFee: isFieldVariable(topUpPlacementFeeType, topUpPlacementFeeApplicable)
            ? topUpMaxPlacementFee
            : null,
          topUpMinPlacementFee: isFieldVariable(topUpPlacementFeeType, topUpPlacementFeeApplicable)
            ? topUpMinPlacementFee
            : null,
          topUpOperatingExpenseApplicable,
          topUpOperatingExpenseType: isFieldApplicable(topUpOperatingExpenseApplicable)
            ? topUpOperatingExpenseType
            : null,
          topUpMaxOperatingExpense: isFieldVariable(
            topUpOperatingExpenseType,
            topUpOperatingExpenseApplicable
          )
            ? topUpMaxOperatingExpense
            : null,
          topUpMinOperatingExpense: isFieldVariable(
            topUpOperatingExpenseType,
            topUpOperatingExpenseApplicable
          )
            ? topUpMinOperatingExpense
            : null,
          defaultTopUpOperatingExpenses:
            isFieldVariable(topUpOperatingExpenseType, topUpOperatingExpenseApplicable) ||
            isFieldValueFixed(topUpOperatingExpenseType || '', topUpOperatingExpenseApplicable)
              ? defaultTopUpOperatingExpenses
              : 0,
          topupExitLoad:
            isFieldApplicable(topupExitLoadDetailsApplicable) &&
            isFieldTypeText(topupExitLoadDetailsType || '')
              ? makeStringInSingleLine(topupExitLoad || '')
              : null,
          topupAdditionalReturnApplicable,
          topupAdditionalReturnType: isFieldApplicable(topupAdditionalReturnApplicable)
            ? topupAdditionalReturnType
            : '',
          topupDefaultAdditionalReturn: isFieldApplicable(topupAdditionalReturnApplicable)
            ? topupDefaultAdditionalReturn
            : null,
          topupMinAdditionalReturn: isFieldVariable(
            topupAdditionalReturnType,
            topupAdditionalReturnApplicable
          )
            ? topupMinAdditionalReturn
            : null,
          topupMaxAdditionalReturn: isFieldVariable(
            topupAdditionalReturnType,
            topupAdditionalReturnApplicable
          )
            ? topupMaxAdditionalReturn
            : null,
          topupExitLoadDetailsApplicable,
          topupExitLoadDetails:
            isFieldApplicable(topupExitLoadDetailsApplicable) &&
            isFieldTypeTabular(topupExitLoadDetailsType || '')
              ? topupExitLoadDetails.map((item) => ({
                  ...item,
                  exitLoad: makeStringInSingleLine(item.exitLoad || ''),
                  duration: makeStringInSingleLine(item.duration || ''),
                }))
              : [],
          topupOperatingExpenseInWords: isFieldValueInWords(
            topUpOperatingExpenseType || '',
            topUpOperatingExpenseApplicable
          )
            ? topupOperatingExpenseInWords
            : '',
          topupCarryShareApplicable,
          topupCarryShareType: isFieldApplicable(topupCarryShareApplicable)
            ? topupCarryShareType
            : '',
          topupCarryShare: isFieldApplicable(topupCarryShareApplicable) ? topupCarryShare : null,
          topupMinCarryShare: isFieldVariable(topupCarryShareType, topupCarryShareApplicable)
            ? topupMinCarryShare
            : null,
          topupMaxCarryShare: isFieldVariable(topupCarryShareType, topupCarryShareApplicable)
            ? topupMaxCarryShare
            : null,
          topupContributionAmtApplicable,
          topupExitLoadDetailsType: isFieldApplicable(topupExitLoadDetailsApplicable)
            ? topupExitLoadDetailsType
            : null,
        }
      : topUpPlanInitialValues;
  } catch (error) {
    console.error('Error in UpdatedTopUpValues:', error);
    return topUpPlanInitialValues;
  }
};

export const individualTopupDocuments = (
  application: ApplicationProps | null,
  role: USER_ROLES,
  documentsData?: Document | string
): documentProps[] => {
  const { applicants = [], hasPOA = false, banks } = application || {};
  return applicants.map((applicant, applicant_index) => {
    let docData = '';
    if (
      !hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      if (
        onboardingTypeMasters[applicants[0].onboardingType as string] ===
        onboardingTypeMasters.minor
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.MINOR;
      } else {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      }
    }
    if (
      hasPOA &&
      applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
    ) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
    }
    if (!hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
    }
    if (hasPOA && checkNormalNri(applicant.status as string, applicant.statusSubType)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
    }
    if (!hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_PIO;
    }
    if (hasPOA && checkNriPIO(applicant.status as string, applicant.statusSubType as string)) {
      docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA_PIO;
    }
    return {
      documents:
        typeof documentsData !== 'undefined'
          ? ((documentsData as Document)[docData] || [])
              .filter((document) => {
                if (applicant.amlCheck && document.documentType === 'compliance_document_topup') {
                  return;
                }
                return document;
              })
              .map((_doc) => {
                if (_doc.documentType === 'bankAccountProofTopUp' && banks?.length) {
                  if (
                    banks.filter(
                      (bank) =>
                        !bank.pennydropVerified && bank.defaultBankAccount && !!bank?.isTopup
                    ).length !== 0 &&
                    applicant_index === 0
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                }
                return _doc;
              })
              .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { documents: existingDocuments = [] } = applicant || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType && !!doc?.isTopup)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                        const {
                          id,
                          documentName = '',
                          documentType = '',
                          documentId = '',
                          isActive = true,
                          file = undefined,
                        } = doc;
                        const isApplicant = Object.keys(doc).includes('applicantId');
                        return {
                          id,
                          [isApplicant ? 'applicantId' : 'topupApplicantId']:
                            application?.topupInitiated
                              ? isApplicant
                                ? applicant?.applicantId
                                : applicant?.id
                              : applicant?.id,
                          documentType,
                          documentName,
                          documentId,
                          isActive,
                          file,
                          options,
                          required,
                          isVisible: true,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            ind.toString()) as string,
                          errorOnUpload: document_object.errorOnUpload,
                        };
                      })
                    : [
                        {
                          documentType,
                          documentName,
                          required,
                          options,
                          isVisible: true,
                          uniqueKey: (applicant_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '0') as string,
                          ...document_object,
                        },
                      ],
                  required,
                  multipleFiles,
                  options,
                };
              })
          : [],
    };
  });
};

export const nonIndividualTopupDocuments = (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[]
): nonIndDocumentProps[] => {
  const { applicants = [], banks } = application || {};
  return applicants.map((applicant, applicant_index) => {
    return {
      documents: documentsData
        .filter((document) => {
          if (applicant.amlCheck && document.documentType === 'compliance_document_topup') {
            return;
          }
          return document;
        })
        .filter((ele) => ele)
        .map((doc) => {
          if (
            [
              'board_resolution_topup',
              'authorised_signatories_topup',
              'Pan_card_authorised_signatories_topup',
              'aadhar_card_authorised_signatories_topup',
            ].includes(doc.documentType) &&
            application?.groupSignatoriesModified
          )
            return {
              ...doc,
              required: 'true',
            };
          if (doc.documentType === 'bankAccountProofTopUp' && banks?.length) {
            if (
              banks.filter(
                (bank) => !bank.pennydropVerified && bank.defaultBankAccount && !!bank?.isTopup
              ).length !== 0 &&
              applicant_index === 0
            ) {
              return { ...doc, required: 'true' };
            }
          }
          return doc;
        })
        .map((doc, index) => {
          const { documentType, documentName, multipleFiles, required, options } = doc;
          const { documents: existingDocuments = [] } = applicant || {};
          const docsOfCurrentDocType = existingDocuments
            .filter((doc) => doc.documentType === documentType)
            .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
          return {
            documentType: documentType,
            documentName: documentName,
            documentsList: docsOfCurrentDocType.length
              ? docsOfCurrentDocType.map((doc, ind) => {
                  const {
                    id,
                    documentName = '',
                    documentType = '',
                    documentId = '',
                    isActive = true,
                    file = undefined,
                  } = doc;
                  const isApplicant = Object.keys(doc).includes('applicantId');

                  return {
                    id,
                    [isApplicant ? 'applicantId' : 'topupApplicantId']: application?.topupInitiated
                      ? isApplicant
                        ? applicant?.applicantId
                        : applicant?.id
                      : applicant?.id,
                    documentType,
                    documentName,
                    documentId,
                    isActive,
                    file,
                    options,
                    required,
                    isVisible: true,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      ind.toString()) as string,
                    errorOnUpload: document_object.errorOnUpload,
                  };
                })
              : [
                  {
                    documentType,
                    documentName,
                    required,
                    options,
                    isVisible: true,
                    uniqueKey: (applicant_index.toString() +
                      '-' +
                      index.toString() +
                      '-' +
                      '0') as string,
                    ...document_object,
                  },
                ],
            required,
            multipleFiles,
            options,
          };
        }),
    };
  });
};

export const isReportTypeErrorLog = (reportType: string): boolean => {
  return reportType.toLowerCase() === 'errorLogs'.toLowerCase();
};

/**
 * @function truncateText - Truncates the text.
 *                  `(text: string, maxLength: number)` => `string`
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (!text) return 'NA';
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const checkIfOtherSetupFeeApplicableReqd = (
  setupFeeType: string,
  setupFeeApplicable: string
): boolean => {
  return (
    Object.keys(FEE_TYPE_MASTER).includes(setupFeeType) &&
    YES_NO_MASTER[setupFeeApplicable.toLowerCase()] === YES_NO_MASTER.yes
  );
};

export const isFieldTypeTabular = (fieldType: string): boolean => {
  return TEXT_TABULAR_MASTER[fieldType] === TEXT_TABULAR_MASTER.tabular;
};

export const isFieldTypeText = (fieldType: string): boolean => {
  return TEXT_TABULAR_MASTER[fieldType] === TEXT_TABULAR_MASTER.text;
};
export const getCurrentStep = (
  applicationType: string,
  current: string,
  isTopUp: boolean,
  isSaveLater: boolean,
  createdAt = '',
  toggler: togglerType = {} as togglerType
): number => {
  const navList =
    applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? getSideNavComponent(NonIndividualMenuItemListLink(!!isTopUp), createdAt, toggler)
      : getSideNavComponent(MenuItemListLink(!!isTopUp), createdAt, toggler);

  const normalizedCurrent = current.split('/').pop();
  const stepIndex = navList.findIndex((item) => item === normalizedCurrent);
  const currentStep = stepIndex + 1;

  return !SAVE_LATER_VALIDATION_CHECK && isSaveLater ? currentStep - 1 : currentStep;
};

export const navigateToNextStep = (
  currentPath: string,
  role: string,
  id: string,
  isSaveLater = false,
  applicant1ReferenceId: string,
  applicationType: string,
  isTopUp: boolean,
  createdAt = '',
  toggler: togglerType = {} as togglerType
): string => {
  const navList =
    applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
      ? getSideNavComponent(NonIndividualMenuItemListLink(!!isTopUp), createdAt, toggler)
      : getSideNavComponent(MenuItemListLink(!!isTopUp), createdAt, toggler);
  const normalizedCurrent = currentPath.split('/').pop();
  const currentIndex = navList.findIndex((path) => path === normalizedCurrent);
  const nextIndex = currentIndex + 1;
  if (nextIndex < navList.length && !isSaveLater) {
    return navList[nextIndex];
  }
  // Below Logic is for last page navigation
  // Handle INVESTOR role
  if (role === USER_ROLES.INVESTOR) {
    return `/${
      isTopUp ? 'topup' : 'investment-details'
    }/${applicant1ReferenceId}/application-details`;
  }

  // Handle POA/AMC Approver role
  if (role === USER_ROLES.POAAPPROVER || role === USER_ROLES.AMCAPPROVER) {
    return `/application-details/${id}`;
  }

  // Handle Save Later path
  if (isSaveLater) {
    return `/applications`;
  }

  // Handle based on application type
  return applicationType === APPLICATION_TYPE.NON_INDIVIDUAL
    ? `/non-individual-application-preview/${id}`
    : `/application-preview/${id}`;
};
